import { c as _c } from "react/compiler-runtime";
import { SpartanProductCustomizeColorList } from '@/app/lcv/components/sections/spartan/products/customize/configurator/color-list';
import type { SpartanProductCustomizeColorPanelProps } from '@/app/lcv/components/sections/spartan/products/customize/configurator/color-panel/types';
import { CUSTOMIZE_CONTROLS_REVEAL_OFFSET } from '@/app/lcv/components/sections/spartan/products/customize/constants';
import { SPARTAN_PRODUCT_CUSTOMIZE_TRACKING } from '@/app/lcv/components/sections/spartan/products/customize/tracking';
import { SPARTAN_PRODUCT_OUTLINE_NONE_CLASS_NAME } from '@/app/lcv/components/sections/spartan/products/shared/icon-button';
import { getSpartanRevealElementProps, SPARTAN_REVEAL_PRESET } from '@/app/lcv/components/sections/spartan/products/shared/reveal';
import { InteriorColorSwatchFace } from '@/app/lcv/components/shared/color-list/interior-color-swatch-face';
import { SPARTAN_PRODUCT_CUSTOMIZE_INTERIOR_COLOR_MOCK, SPARTAN_PRODUCT_CUSTOMIZE_LABELS } from '@/app/lcv/contents/spartan/products/shared/customize-common-fields.data';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { formatPrice } from '@/app/utils/format';
export const SpartanProductCustomizeColorPanel = t0 => {
  const $ = _c(34);
  const {
    theme: t1,
    colors,
    selectedColor,
    onSelectColor,
    onPrepareColorPreview,
    colorName,
    colorExtra,
    interiorColor,
    exteriorTwoToneSolidColor,
    isInteriorView: t2
  } = t0;
  const theme = t1 === undefined ? "light" : t1;
  const isInteriorView = t2 === undefined ? false : t2;
  const isDark = theme === "dark";
  if (!colors.length && !isInteriorView) {
    return null;
  }
  const detailName = isInteriorView ? interiorColor?.nameTh || SPARTAN_PRODUCT_CUSTOMIZE_INTERIOR_COLOR_MOCK.name : colorName;
  const detailPrefix = isInteriorView ? SPARTAN_PRODUCT_CUSTOMIZE_LABELS.interiorColorPrefix : SPARTAN_PRODUCT_CUSTOMIZE_LABELS.colorPrefix;
  const selectLabel = isInteriorView ? SPARTAN_PRODUCT_CUSTOMIZE_LABELS.selectInteriorColor : SPARTAN_PRODUCT_CUSTOMIZE_LABELS.selectColor;
  const t3 = isDark ? "bg-gray-900 text-white" : "bg-silver-100";
  let t4;
  if ($[0] !== t3) {
    t4 = cn("order-4 flex flex-col justify-center overflow-hidden rounded-lg px-4 py-4 md:p-4 lg:order-0 lg:col-start-3 lg:row-start-2 lg:h-0 lg:min-h-full", t3);
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.colorList
    });
    t6 = getSpartanRevealElementProps({
      preset: SPARTAN_REVEAL_PRESET.collection,
      scrollOffset: CUSTOMIZE_CONTROLS_REVEAL_OFFSET
    });
    $[2] = t5;
    $[3] = t6;
  } else {
    t5 = $[2];
    t6 = $[3];
  }
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.colorTitle
    });
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== selectLabel || $[6] !== t7) {
    t8 = <p className="sr-only" {...t7}>{selectLabel}</p>;
    $[5] = selectLabel;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== colorExtra || $[9] !== detailName || $[10] !== detailPrefix || $[11] !== isDark || $[12] !== isInteriorView) {
    t9 = !!detailName && <div className="text-body-1-fixed flex items-baseline justify-between gap-2" {...createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.colorDetail
    })}><span className={isDark ? "text-white" : "text-gray-900"} {...createDataAttributes({
        test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.colorDetailName
      })}><span className="font-noto-bold">{detailPrefix}</span>{detailName}</span>{!isInteriorView && !!colorExtra && <span className={isDark ? "text-white" : "text-gray-900"} {...createDataAttributes({
        test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.colorDetailPrice
      })}>+{formatPrice(colorExtra)}</span>}</div>;
    $[8] = colorExtra;
    $[9] = detailName;
    $[10] = detailPrefix;
    $[11] = isDark;
    $[12] = isInteriorView;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== colors || $[15] !== detailName || $[16] !== exteriorTwoToneSolidColor || $[17] !== interiorColor || $[18] !== isDark || $[19] !== isInteriorView || $[20] !== onPrepareColorPreview || $[21] !== onSelectColor || $[22] !== selectedColor || $[23] !== theme) {
    t10 = isInteriorView ? <ul className="flex flex-wrap items-center justify-center gap-3" {...createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.colorSwatches
    })}><li className="size-12 shrink-0 leading-none"><button type="button" aria-label={detailName} aria-pressed="true" className={cn("block size-full cursor-default overflow-hidden rounded-md border-2 p-0.5 focus-visible:outline-2 focus-visible:outline-offset-2", SPARTAN_PRODUCT_OUTLINE_NONE_CLASS_NAME, isDark ? "border-white focus-visible:outline-white" : "border-gray-800 focus-visible:outline-gray-800")} {...createDataAttributes({
          test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.colorItem(0),
          active: "true"
        })}><InteriorColorSwatchFace interiorColor={interiorColor} fallbackColor={SPARTAN_PRODUCT_CUSTOMIZE_INTERIOR_COLOR_MOCK.swatchColor} /></button></li></ul> : <SpartanProductCustomizeColorList theme={theme} colors={colors} selectedColor={selectedColor} onSelectColor={onSelectColor} onPrepareColorPreview={onPrepareColorPreview} twoToneSolidColor={exteriorTwoToneSolidColor} />;
    $[14] = colors;
    $[15] = detailName;
    $[16] = exteriorTwoToneSolidColor;
    $[17] = interiorColor;
    $[18] = isDark;
    $[19] = isInteriorView;
    $[20] = onPrepareColorPreview;
    $[21] = onSelectColor;
    $[22] = selectedColor;
    $[23] = theme;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t8 || $[27] !== t9) {
    t11 = <div className="flex flex-col gap-3 md:gap-4">{t8}{t9}{t10}</div>;
    $[25] = t10;
    $[26] = t8;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t11 || $[30] !== t4 || $[31] !== t5 || $[32] !== t6) {
    t12 = <div className={t4} {...t5} {...t6}>{t11}</div>;
    $[29] = t11;
    $[30] = t4;
    $[31] = t5;
    $[32] = t6;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
};